import { createStore, applyMiddleware } from 'redux';


export const store = createStore(
    applyMiddleware(
    )
);